// extracted by mini-css-extract-plugin
export default {"root":"Header_root__vo69w","title":"Header_title__QOqjR","subTitle":"Header_subTitle__xM4xB"};